<template>
  <div :class="dataStyle">
    <img :src="dataImg" class="tc pr12" v-if="dataImg" />
    <span class="fs-12 tc fw-800" :class="dataTextColor">{{ dataText }}</span>
  </div>
</template>
<script>
export default {
  name: "ToastMsg",
  props: ["dataText", "dataImg", "dataStyle", "dataTextColor"],
};
</script>
